<template>
    <div>
        <ejs-button cssClass='e-link' v-if='isAvailable' v-on:click.native='clientBtnClick(tradingGroupId)'>{{tradingGroupName}}</ejs-button>
        <span v-else>{{tradingGroupName}}</span>
    </div>
</template>

<script>
    import Vue from "vue";
    import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
    import router from '../../router/index';

    Vue.use(ButtonPlugin);
    export default {
        name: 'ColumnTemplate',
        data() {
            return {
                data: {}
            }
        },
        methods: {
            clientBtnClick: function (id) {
                router.push({ name: "ATGReports", params: { tradingGroupId: id } });
            }
        },
        computed: {
            tradingGroupId: function () {
                return this.data.tradingGroupId;
            },
            tradingGroupName: function () {
                return this.data.tradingGroupName;
            },
            isAvailable: function () {
                return this.$store.state.permissions["Permissions.Reports.View"] ? true : false;
            }
        }
    }
</script>

<style scoped>
</style>